module.exports = __webpack_public_path__ + "media/stylesheets/images/SAReye-RGB-BW-small-transparent-1d0d8fc3d7841c2bd46c1d85fadc1654.png";